import { environment } from './environments/environment';

// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    aws_appsync_graphqlEndpoint: environment.urlAppsyncGraphQl,
    aws_appsync_region: environment.paramAppsynRegion,
    // aws_appsync_authenticationType: 'AMAZON_COGNITO_USER_POOLS',
    aws_appsync_authenticationType: 'API_KEY',
    aws_appsync_apiKey: environment.paramAppsyncApiKey,
    userPoolId: environment.paramAppsynUserPoolId,
    userPoolWebClientId: environment.paramAppsynUserPoolWebClientId,
    AuthMode: 'API_KEY',
    // ApiKey: "da2-w3jflzvcmnghhbiaog3whnpjle",
    ClientDatabasePrefix: 'FOLIO_AURORA_API_KEY'
};

export default awsmobile;
